import Image from 'next/image';

import { Visible } from 'components';

interface IProps {
  score?: number;
  passingScore?: number;
}

const ResultImage: React.FC<IProps> = ({ score, passingScore }) => (
  <div className="flex justify-center">
    <Visible
      if={(score || 0) >= (passingScore || 0)}
      else={
        <Image
          src="/images/bad-result.png"
          alt="bad-result"
          width={140}
          height={100}
          loading="lazy"
          className="drop-shadow-[0_2px_50px_rgba(255,255,0,0.4)]"
          title="Yaxshi ball to'play olmagan foydalanuvchiga ko'rinadigon rasm"
        />
      }
    >
      <Image
        src="/images/happy-result.png"
        alt="happy-result"
        width={140}
        height={100}
        loading="lazy"
        className="drop-shadow-[0_2px_50px_rgba(255,255,0,0.4)]"
        title="Yaxshi ball to'plagan foydalanuvchiga ko'rinadigon rasm"
      />
    </Visible>
  </div>
);

export default ResultImage;
